import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, MapPin, Phone, Mail } from "lucide-react";
import { useLang } from "@/i18n/LanguageProvider";
import { WA_DISPLAY, CONTACT_EMAIL, LOCATION, INSTAGRAM, FACEBOOK, waUrl, BOOK_MESSAGE } from "@/lib/contact";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="bg-bark text-cream pt-20 pb-10" data-testid="site-footer">
      <div className="container-px mx-auto grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-4 mb-5">
            <img
              src="https://customer-assets.emergentagent.com/job_agung-wiwin-bali/artifacts/596tdaku_3.jpg"
              alt="Agung Wiwin Homestay"
              className="w-16 h-16 object-contain rounded-full bg-white p-1.5"
            />
            <div className="font-display text-3xl">Agung Wiwin Homestay</div>
          </div>
          <p className="text-cream/70 max-w-md leading-relaxed">{t.footer.tagline}</p>
          <div className="flex items-center gap-3 mt-6">
            <a href={INSTAGRAM} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-cream/30 grid place-items-center hover:bg-cream/10" data-testid="footer-instagram">
              <Instagram className="w-4 h-4" />
            </a>
            <a href={FACEBOOK} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-cream/30 grid place-items-center hover:bg-cream/10" data-testid="footer-facebook">
              <Facebook className="w-4 h-4" />
            </a>
            <a href={waUrl(BOOK_MESSAGE())} target="_blank" rel="noreferrer" className="ml-2 inline-flex items-center gap-2 rounded-full bg-wa px-5 py-2.5 text-sm text-white hover:opacity-90" data-testid="footer-whatsapp">
              <Phone className="w-4 h-4" /> WhatsApp
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="eyebrow text-cream/70 mb-4">{t.footer.links}</div>
          <ul className="space-y-2 text-cream/80">
            <li><Link to="/rooms" className="hover:text-white">{t.nav.rooms}</Link></li>
            <li><Link to="/restaurant" className="hover:text-white">{t.nav.restaurant}</Link></li>
            <li><Link to="/laundry" className="hover:text-white">{t.nav.laundry}</Link></li>
            <li><Link to="/travel" className="hover:text-white">{t.nav.travel}</Link></li>
            <li><Link to="/faq" className="hover:text-white">{t.nav.faq}</Link></li>
            <li><Link to="/contact" className="hover:text-white">{t.nav.contact}</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="eyebrow text-cream/70 mb-4">{t.footer.contact}</div>
          <ul className="space-y-3 text-cream/80">
            <li className="flex items-start gap-3"><MapPin className="w-4 h-4 mt-1 shrink-0" />{LOCATION}</li>
            <li className="flex items-start gap-3"><Phone className="w-4 h-4 mt-1 shrink-0" />{WA_DISPLAY}</li>
            <li className="flex items-start gap-3"><Mail className="w-4 h-4 mt-1 shrink-0" />{CONTACT_EMAIL}</li>
          </ul>
        </div>
      </div>
      <div className="container-px mx-auto mt-14 pt-6 border-t border-cream/15 flex flex-col md:flex-row gap-3 justify-between text-xs text-cream/60">
        <div>© {new Date().getFullYear()} Agung Wiwin Homestay. {t.footer.rights}</div>
        <div>Pererenan · Canggu · Bali</div>
      </div>
    </footer>
  );
}
